import './style.scss';

import { IconColor, IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { IconName, findIcon } from 'utils/handleIcon';
import { FormError } from 'views/mutual/formErrorScroll';

export type SelectorDataProps = {
  selectedOption: string;
  setSelectedOption: (option: string) => void;
  error?: string;
};

export type SelectorProps = {
  options: string[];
  disabledOption?: string;
  disabled?: boolean;
} & SelectorDataProps;

export const Selector = (props: SelectorProps) => {
  const { options, selectedOption, setSelectedOption, disabledOption, error, disabled } = props;

  const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(event.target.value);
  };

  const icon = findIcon(IconName.arrow);

  return (
    <div className="selector">
      <div className="selectorArrow">
        <SvgIcon icon={icon} size={IconSize.icon_s} color={IconColor.gray} />
        <select disabled={disabled} className="selectorControl" value={selectedOption} onChange={handleSelect}>
          <option selected disabled style={{ color: '#737373' }}>
            {disabledOption}
          </option>
          {options?.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
          <optgroup label=""></optgroup>
        </select>
      </div>
      <FormError className="selector_error" error={error} />
    </div>
  );
};

export type SelectorOptionType = {
  label: string;
  value: string | number;
  }
export type LabelValueSelectorProps = {
  options: SelectorOptionType[];
  disabledOption?: string;
  disabled?: boolean;
} & SelectorDataProps;

export const LabelValueSelector = (props: LabelValueSelectorProps) => {
  const { options, selectedOption, setSelectedOption, disabledOption, error , disabled} = props;

  const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(event.target.value);
  };

  const icon = findIcon(IconName.arrow);

  return (
    <div className="selector">
      <div className="selectorArrow">
        <SvgIcon icon={icon} size={IconSize.icon_s} color={IconColor.gray} />
        <select disabled={disabled} className="selectorControl" value={selectedOption} onChange={handleSelect}>
          <option selected disabled style={{ color: '#737373' }}>
            {disabledOption}
          </option>
          {options?.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
          <optgroup label=""></optgroup>
        </select>
      </div>
      <FormError className="selector_error" error={error} />
    </div>
  );
};

export const TimeSelector = (props: SelectorProps) => {
  const { options, selectedOption, setSelectedOption, disabledOption, error } = props;

  const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(event.target.value);
  };

  const icon = findIcon(IconName.arrow);

  return (
    <div className="selector">
      <div className="selectorArrow">
        <SvgIcon icon={icon} size={IconSize.icon_s} color={IconColor.gray} />
        <select className="timeSelectorControl" value={selectedOption} onChange={handleSelect}>
          <option value="" disabled style={{ color: '#737373' }}>
            {disabledOption}
          </option>
          {options?.map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
          <optgroup label=""></optgroup>
        </select>
      </div>
      <FormError className="selector_error" error={error} />
    </div>
  );
};